import React from 'react';
import Svg, { Path } from 'react-native-svg';

const DirectionsIcon = ({
  width = 24,
  height = 24,
  color = '#e8eaed',
  style,
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 -960 960 960" style={style}>
      <Path
        d="m600-120-240-84-186 72q-20 8-37-4.5T120-170v-560q0-13 7.5-23t20.5-15l212-72 240 84 186-72q20-8 37 4.5t17 33.5v560q0 13-7.5 23T812-192l-212 72Zm-40-98v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z"
        fill={color}
      />
    </Svg>
  );
};

export default DirectionsIcon;
